import React, { Component } from 'react';

const getScrollTop = () =>
  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

const scrollWatcher = WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        scrollTop: getScrollTop(),
      };
    }

    componentDidMount() {
      window.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll = () => requestAnimationFrame(() => this.setState({ scrollTop: getScrollTop() }));

    render() {
      const { scrollTop } = this.state;

      return <WrappedComponent scrollTop={scrollTop} {...this.props} />;
    }
  };
};

export default scrollWatcher;



// WEBPACK FOOTER //
// ../ui-components/hocs/scroll-watcher.jsx